import { type DebouncedFunc, debounce } from 'lodash';
import { DependencyList, useMemo } from 'react';

/**
 * Create a memoized debounced callback.
 *
 * @param callback function to call
 * @param delay debounce delay
 * @param deps dependencies to pass to useMemo
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useDebounce<T extends (...args: any) => any>(
  callback: T,
  delay: number,
  deps?: DependencyList | undefined
): DebouncedFunc<T> {
  return useMemo(
    () => debounce(callback, delay),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [callback, delay, ...(deps ?? [])]
  );
}

export default useDebounce;
